<!-- Main Content-->
<div class="main-content side-content pt-0">

	<div class="main-container container-fluid">
		<div class="inner-body">

				<!-- Page Header -->
				<div class="page-header">
					<div class="dashboard-top">
						<button mat-icon-button  color="primary" (click)="reload()">
								<mat-icon>sync</mat-icon>
						</button>
					</div>
					<div class="dashboard-header">
						<button type="button" (click)="goBack()" color="primary" mat-button>
							<mat-icon>chevron_left</mat-icon>
						</button>
						<h2 class="webapp-title-secondary">Users with access to WebApp</h2>
					</div>

				<div>
					<ol class="breadcrumb">
						<li class="breadcrumb-item"><a href="javasscript: void(0)">Webapp Manager</a></li>
						<li class="breadcrumb-item active" aria-current="page">User App Session</li>
					</ol>
				</div>
				<div class="d-flex">
					<div class="justify-content-center">
						<button *ngIf="userSelected" mat-icon-button  color="primary" (click)="reloadThisClientApps()">
							<mat-icon>sync</mat-icon>
						</button>
					</div>
				</div>

				
			</div>

			<!-- <mat-spinner *ngIf="isLoadingUserApps()"></mat-spinner> -->
			<!-- <app-webapp-user-config *ngIf="userSelected" [info]="userSelected"></app-webapp-user-config> -->
			
			 <!--Row-->
			 <div class="row row-sm" *ngIf="!userSelected">
				<div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
					<div class="custom-card">
						<div>
							<div class="table-responsive border userlist-table">
								
								<table class="table card-table table-striped table-vcenter text-nowrap mb-0">
									<thead>
										<tr>
											<th class="wd-lg-8p"><span>Username</span></th>
											<th class="wd-lg-20p"><span>Client name</span></th>
											<th class="wd-lg-20p"><span>Status</span></th>
											<th class="wd-lg-20p"><span>Email</span></th>
											<th class="wd-lg-20p"><span>Role</span></th>
											<th class="wd-lg-20p">Apps</th>
										</tr>
									</thead>
									<tbody>
										<mat-spinner class="center" *ngIf="isLoading()"></mat-spinner>
										<tr *ngFor="let row of getClientAppList()" (click)="selectUser(row)" class="my-row">
											<td>
												<img *ngIf="row.username" alt="avatar" class="rounded-circle avatar-md me-2" src="../assets/img/users/1.jpg">
												<span *ngIf="row.username">{{row.username}}</span>
											</td>
											<td>{{row.name}} {{row.lastname}}</td>
											<td class="text-center">
												<span class="label text-muted d-flex"><span class="dot-label bg-gray-300 me-1"></span>Active</span>
											</td>
											<td>
												<a href="javascript: void(0)">{{row.email}}</a>
											</td>
											<td>
												{{row.role}}
											</td>
											<td>
												<p>{{ row.apps | json }}</p>
												<!-- <a href="#" class="btn btn-sm btn-primary">
													<i class="fe fe-search"></i>
												</a>
												<a href="#" class="btn btn-sm btn-info">
													<i class="fe fe-edit-2"></i>
												</a>
												<a href="#" class="btn btn-sm btn-danger">
													<i class="fe fe-trash"></i>
												</a> -->
											</td>
										</tr>
										
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div><!-- COL END -->
			</div>

			<h4 class="webapp-title-secondary">New users</h4>
			<ol class="breadcrumb">
				<li class="breadcrumb-item">New accounts</li>
				<li class="breadcrumb-item active" aria-current="page"><a href="javascript: void(0)" (click)="goToCrudView('password_reset')">Password reset</a></li>
			</ol>
			<!-- row closed  -->
			<!--Row-->
			<!-- <div class="row row-sm" *ngIf="!userSelected">
			<div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
				<div class="card custom-card" style="padding: 1rem;">
					<mat-slide-toggle (change)="onSlideToggleEvent($event,'username')">Use email as username</mat-slide-toggle>
					<mat-slide-toggle (change)="onSlideToggleEvent($event,'password')">Autogenerate Password</mat-slide-toggle>
					<p>Role: user (for clients)</p>
				</div>
			</div>
			</div> -->
			<!-- <app-dynamic-crud *ngIf="!userSelected" [crudConfig]="config1"></app-dynamic-crud>

			<h3>Assign App to Client</h3>
			<app-dynamic-crud *ngIf="userSelected" [crudConfig]="config2"></app-dynamic-crud> -->

		</div>
	</div>
</div>